import CustomerCareLocaleKeys from '../../locales/keys';
import { path } from 'ramda';
import { CustomerSearchModelSelector, CustomerSearchRecordCountSelector } from '../../reducers/selectors/search.customer.selectors';
import { setCustomerSearchModel } from '../../reducers/actions/search.customer.actions';
import { setGiftCardSearchModel } from '../../reducers/actions/search.giftcard.actions';
import { setCouponSearchModel } from '../../reducers/actions/search.coupon.actions';
import { hideSearchPanel, setSearchType } from '../../reducers/actions/search.actions';
import { IsSearchPanelVisibleSelector, SearchIsFetchingResultsSelector, SearchTypeSelector } from '../../reducers/selectors/search.selectors';
import { GiftCardSearchRecordCountSelector, GiftCardSearchModelSelector } from '../../reducers/selectors/search.giftcard.selectors';
import { CouponSearchRecordCountSelector, CouponSearchModelSelector } from '../../reducers/selectors/search.coupon.selectors';
import PanelAutoClose from 'invision-core/src/utilities/panel.auto.close.handler';
import { SEARCH_DROPDOWN_CONSTANTS } from './search.constants';
export function SearchController($element, $ngRedux, $timeout) {
  var _this = this;
  var disconnectRedux;
  var mapStateToTarget = function mapStateToTarget(store) {
    return {
      couponSearchModel: CouponSearchModelSelector(store),
      couponSearchResultCount: CouponSearchRecordCountSelector(store),
      customerSearchModel: CustomerSearchModelSelector(store),
      customerSearchResultCount: CustomerSearchRecordCountSelector(store),
      giftCardSearchModel: GiftCardSearchModelSelector(store),
      giftCardSearchResultCount: GiftCardSearchRecordCountSelector(store),
      isFetchingResults: SearchIsFetchingResultsSelector(store),
      isSearchPanelVisible: IsSearchPanelVisibleSelector(store),
      searchType: SearchTypeSelector(store)
    };
  };
  this.$onInit = function () {
    _this.customerCareLocaleKeys = CustomerCareLocaleKeys;
    _this.isVisible = false;
    _this.pageNumber = 1;
    var controllerActions = {
      hideSearchPanel: hideSearchPanel,
      setCustomerSearchModel: setCustomerSearchModel,
      setGiftCardSearchModel: setGiftCardSearchModel,
      setCouponSearchModel: setCouponSearchModel,
      setSearchType: setSearchType
    };
    disconnectRedux = $ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
      _this.state = state;
      _this.actions = actions;
    });

    // This is used to call a function in the child component (searchFields) to clear the data given on
    // search results and search type is Individual or Company due to the component not being re-instantiated.
    _this.searchFieldsApiFactory = function (api) {
      _this.searchFieldsApi = api;
    };
    _this.changePageNumber = function (pageNum) {
      _this.pageNumber = pageNum;
    };
    _this.pushCustomerSearchModel = function (updatedModel) {
      _this.actions.setCustomerSearchModel(updatedModel);
    };
    _this.pushGiftCardSearchModel = function (updatedModel) {
      _this.actions.setGiftCardSearchModel(updatedModel);
    };
    _this.pushCouponSearchModel = function (updatedModel) {
      _this.actions.setCouponSearchModel(updatedModel);
    };
    _this.isEmpty = function () {
      return _this.state.customerSearchResultCount <= 1 && _this.state.giftCardSearchResultCount <= 1;
    };
    _this.searchPanelEvent = PanelAutoClose.autoCloseRegistration({
      element: 'search',
      toggleButtonElement: '#navigator-item-search',
      isHidden: _this.isSearchPanelHidden,
      callback: _this.actions.hideSearchPanel
    });
  };
  this.$onChanges = function (changesObj) {
    if (changesObj.isVisible && changesObj.isVisible.currentValue) {
      if (!_this.state.customerSearchResultCount && _this.state.searchType !== SEARCH_DROPDOWN_CONSTANTS.GIFT_CARD && _this.state.searchType !== SEARCH_DROPDOWN_CONSTANTS.COUPON && _this.state.searchType !== SEARCH_DROPDOWN_CONSTANTS.INDIVIDUAL) {
        _this.actions.setSearchType(SEARCH_DROPDOWN_CONSTANTS.INDIVIDUAL);
      }
      _this.clearSearch();
      $timeout(function () {
        $element.find('input').first().focus();
      });
    }
  };
  this.$onDestroy = function () {
    disconnectRedux();
    PanelAutoClose.unregister(_this.searchPanelEvent);
  };
  this.isSearchPanelHidden = function () {
    return !path(['state', 'isSearchPanelVisible'], _this);
  };
  this.clearSearch = function () {
    if (_this.searchFieldsApi && 'function' === typeof _this.searchFieldsApi.clearSearch) {
      _this.searchFieldsApi.clearSearch();
    }
  };
}

// Definition for the self-contained SearchPanel component
export var Search = {
  template: require('./search.html'),
  controller: SearchController,
  controllerAs: 'Search',
  bindings: {
    isVisible: '<'
  }
};